import { createStore } from 'vuex';
import wx from 'weixin-js-sdk';
import { wechatShare } from '@/api/api';
import { addReadCountLog } from '@/api/newsApi';
import { Toast } from 'vant';

const wechatShareTitle = import.meta.env.VITE_WECHAT_SHARE_TITLE;
const wechatShareDesc = import.meta.env.VITE_WECHAT_SHARE_DESC;
const wechatShareImageUrl = import.meta.env.VITE_WECHAT_SHARE_IMAGE_URL;
const wechatShareUseDefault = import.meta.env.VITE_WECHAT_SHARE_USE_DEFAULT === 'true';
const imageBaseUrl = import.meta.env.VITE_NEWS_IMAGE_BASEURL;

console.log('wechatShareDesc', wechatShareDesc)

const store = createStore({
  // 开发模式下使用strict模式有利于开发过程中代码的合理性，同时可以避免生产环境中由于strict模式下的冲突问题
  strict: process.env.NODE_ENV !== 'production',
  // 状态声明
  state() {
    return {
      isFinishConfig: false,
    };
  },
  // 状态获取器
  getters: {},
  // 状态修改(同步)
  mutations: {
    setTrueIsFinishConfig(state) {
      state.isFinishConfig = true;
    },
  },
  // 状态修改(异步)
  actions: {
    setWechatShare({ state, commit }, shareObj = {}) {
      const ua = window.navigator.userAgent.toLowerCase();
      if (!ua.match(/micromessenger/i)) {
        return;
      }
      const defaultShareObj = {
        title: wechatShareTitle,
        desc: wechatShareDesc,
        imgUrl: wechatShareImageUrl,
        link: window.location.href,
      };
      let newShareObj = null;
      if (wechatShareUseDefault) {
        newShareObj = {
          title: defaultShareObj.title,
          desc: defaultShareObj.desc,
          imgUrl: defaultShareObj.imgUrl,
          link: defaultShareObj.link,
        };
      } else {
        newShareObj = {
          title: shareObj.title ? shareObj.title : defaultShareObj.title,
          desc: shareObj.desc ? shareObj.desc : defaultShareObj.desc,
          imgUrl: shareObj.imgUrl ? shareObj.imgUrl : defaultShareObj.imgUrl,
          link: shareObj.link ? shareObj.link : defaultShareObj.link,
        };
        if (shareObj.imgUrl) {
          const waitDealUrl = shareObj.imgUrl;
          if (!(waitDealUrl.startsWith('https://') || waitDealUrl.startsWith('http://') || waitDealUrl.startsWith('//'))) {
            const waitDealUrlArr = waitDealUrl.split('/');
            waitDealUrlArr.splice(0, 3);
            waitDealUrlArr.unshift(imageBaseUrl);
            newShareObj.imgUrl = waitDealUrlArr.join('/');
          }
        }
      }
      if (!state.isFinishConfig) {
        wechatShare().then((res) => {
          wx.config({
            debug: false,
            appId: res.appid,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
          });
          wx.ready(() => {
            commit('setTrueIsFinishConfig');
            wx.updateAppMessageShareData({
              ...newShareObj,
            });
            wx.updateTimelineShareData({
              ...newShareObj,
            });
          });
          wx.error((err) => {
            Toast.fail(err.errMsg);
          });
        });
      } else {
        wx.updateAppMessageShareData({
          ...newShareObj,
        });
        wx.updateTimelineShareData({
          ...newShareObj,
        });
      }
    },
    addReadCountLog(_, content) {
      if (content.contentId && content.contentType) {
        addReadCountLog(content);
      }
    },
  },
});

export default store;
